import { getPortalSettingsRootUrl } from './utils';
export function getExternalManagePaidUsersUrl() {
  return `${getPortalSettingsRootUrl()}/users/paid-users`;
}